angular.module('virtoCommerce.marketplaceModule')
    .controller('virtoCommerce.marketplaceModule.sellerDetailsController', ['$scope', 'platformWebApp.bladeNavigationService', 'virtoCommerce.marketplaceModule.webApi', 'platformWebApp.settings', 'virtoCommerce.marketplaceModule.approvalPolicyTranslationService',
        function ($scope, bladeNavigationService, marketplaceApi, settings, approvalPolicyTranslationService) {
            var blade = $scope.blade;
            blade.headIcon = 'fas fa-store';
            blade.isLoading = true;

            function initializeBlade(data) {
                blade.currentEntity = angular.copy(data);
                blade.originalEntity = data;
                blade.title = blade.currentEntity.name;

                marketplaceApi.searchFees({ type: 'static', skip: 0, take: 1000 }, function (data) {
                    blade.staticFees = data.results ? data.results : [];

                    blade.isLoading = false;
                });
            }

            blade.refresh = function (parentRefresh) {
                if (parentRefresh) {
                    blade.parentBlade.refresh(true);
                }

                if (!blade.currentEntity && blade.sellerId) {
                    marketplaceApi.getSellerById({ id: blade.sellerId }, (data) => {
                        initializeBlade(data);
                    });
                }
                else {
                    blade.sellerId = blade.currentEntity.id;
                    initializeBlade(blade.currentEntity);
                }
            };

            settings.getValues({ id: 'Marketplace.SellerApprovalPolicy' }, translateBladeApprovalPolicies);
            blade.openApprovalPolicySettingManagement = function () {
                var newBlade = {
                    id: 'settingDetailChild',
                    isApiSave: true,
                    currentEntityId: 'Marketplace.SellerApprovalPolicy',
                    parentRefresh: translateBladeApprovalPolicies,
                    controller: 'platformWebApp.settingDictionaryController',
                    template: '$(Platform)/Scripts/app/settings/blades/setting-dictionary.tpl.html'
                };
                bladeNavigationService.showBlade(newBlade, blade);
            };

            function translateBladeApprovalPolicies(data) {
                blade.approvalPolicies = approvalPolicyTranslationService.translateApprovalPolicies(data);
            }

            blade.toolbarCommands = [
                {
                    name: "platform.commands.save", icon: 'fas fa-save',
                    executeMethod: saveChanges,
                    canExecuteMethod: function () {
                        return blade.canSave();
                    }
                },
                {
                    name: "platform.commands.reset", icon: 'fa fa-undo',
                    executeMethod: function () {
                        angular.copy(blade.originalEntity, blade.currentEntity);
                    },
                    canExecuteMethod: isDirty
                }
            ];

            blade.onClose = function (closeCallback) {
                bladeNavigationService.showConfirmationIfNeeded(isDirty(), blade.canSave(), blade, saveChanges, closeCallback, "marketplace.dialogs.seller-save.title", "marketplace.dialogs.seller-save.message");
            };

            blade.openStaticCommissions = function () {
                var newBlade = {
                    id: 'fees-static',
                    title: 'marketplace.blades.fee-static-list.title',
                    controller: 'virtoCommerce.marketplaceModule.feeStaticListController',
                    template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/blades/fee-static-list.tpl.html',
                    sortDefault: true,
                    onClose: function (closeCallback) {
                        marketplaceApi.searchFees({ type: 'static', skip: 0, take: 1000 }, function (data) {
                            blade.staticFees = data.results ? data.results : [];
                        });
                        closeCallback();
                    }
                };
                bladeNavigationService.showBlade(newBlade, $scope.blade);
            };

            blade.groups = settings.getValues({ id: 'Customer.MemberGroups' });

            var originalBlade;
            blade.uploadLogo = function () {
                var newBlade = {
                    id: "logoUpload",
                    currentEntityId: 'seller_logos',
                    title: 'platform.blades.asset-upload.title',
                    subtitle: blade.currentEntity.name,
                    controller: 'virtoCommerce.assetsModule.assetUploadController',
                    template: 'Modules/$(VirtoCommerce.Assets)/Scripts/blades/asset-upload.tpl.html',
                    fileUploadOptions: {
                        singleFileMode: true,
                        accept: "image/*",
                        suppressParentRefresh: true
                    }
                };
                newBlade.onUploadComplete = function (data) {
                    if (data && data.length) {
                        blade.currentEntity.logo = data[0].url;
                        bladeNavigationService.closeBlade(newBlade);
                    }
                }

                //saving orig blade reference (that is not imageUpload blade) for subsequent showBlade calls
                if (!originalBlade) {
                    originalBlade = bladeNavigationService.currentBlade.id !== "logoUpload" ? bladeNavigationService.currentBlade : bladeNavigationService.currentBlade.parentBlade;
                }
                bladeNavigationService.showBlade(newBlade, originalBlade);
            }

            blade.clearLogo = function () {
                blade.currentEntity.logo = undefined;
            }

            blade.openUrl = function (url) {
                window.open(url, '_blank');
            }

            $scope.setForm = function (form) {
                $scope.formScope = form;
            };

            $scope.$on("new-notification-event", function (event, notification) {
                if (notification.notifyType === "SellerCommissionUpdatedDomainEvent"
                    && blade.currentEntity.id === notification.sellerId) {
                    marketplaceApi.getFeeById({ id: notification.commissionFeeId }, function (data) {
                        blade.currentEntity.commissionFee = data;
                        blade.refresh(true);
                    });
                }
            });

            function isDirty() {
                return !angular.equals(blade.currentEntity, blade.originalEntity);
            }

            blade.canSave = function () {
                return isDirty() && $scope.formScope && $scope.formScope.$valid;
            }

            function saveChanges() {
                blade.isLoading = true;

                marketplaceApi.updateSeller({
                    sellerId: blade.currentEntity.id,
                    sellerName: blade.currentEntity.name,
                    commissionFeeId: blade.currentEntity.commissionFee.id,
                    groups: blade.currentEntity.groups,
                    sellerDetails: {
                        name: blade.currentEntity.name,
                        isActive: blade.currentEntity.isActive,
                        logo: blade.currentEntity.logo,
                        registrationId: blade.currentEntity.registrationId,
                        outerId: blade.currentEntity.outerId,
                        description: blade.currentEntity.description,
                        approvalPolicy: blade.currentEntity.approvalPolicy,
                        deliveryTime: blade.currentEntity.deliveryTime,
                        addresses: blade.currentEntity.addresses,
                    }
                }, function () {
                    blade.refresh(true);
                });
            }

            blade.refresh();
        }
    ]);
